import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortByDate',
  standalone: true
})
export class SortByDatePipe implements PipeTransform {

  transform(array: any[], field: string): any[] {
    if (!array || !field) {
      return array;
    }
    return array.sort((a: any, b: any) => {
      const dateA = new Date(a[field]);
      const dateB = new Date(b[field]);
      return dateB.getTime() - dateA.getTime();
    });
  }
}
